module.exports = __webpack_public_path__ + "img/safari-table-icon.84b460c0.svg";